<script lang="ts">
  import clsx from 'clsx';
  import type { ProgressBarProps } from './types';

  let { progress, size, showText }: ProgressBarProps = $props();

  const progressWidth = $derived.by(() => {
    return progress > 100 ? 100 : progress;
  });

  const sizeClass = $derived.by(() => {
    const sizeClasses: Record<string, string> = {
      small: clsx('h-3'),
      medium: clsx('h-5'),
      large: clsx('h-7'),
    };

    return sizeClasses[size];
  });
</script>

<div class="text-md w-full text-center font-semibold">
  {#if showText}
    <span>
      {progressWidth}%
    </span>
  {/if}
  <div class={clsx('bg-st-yellow', sizeClass)} style={`width: ${progressWidth}%`}></div>
</div>
